module.exports = __webpack_public_path__ + "img/back.32be6e2e.svg";